import { useContext } from "react";
import { UNLOADED, Context, getLoaded } from "./Context";

/**
 * Get the loaded state for an args object.
 * @param {object} args
 */
export var useCommentsLoaded = function useCommentsLoaded(args) {
  var context = useContext(Context);
  return context ? getLoaded(context, args) : UNLOADED;
};
export default useCommentsLoaded;
//# sourceMappingURL=useCommentsLoaded.js.map